module.exports = __webpack_public_path__ + "img/space3.7cc25990.png";